export default __webpack_public_path__ + "static/media/recruit-pg-1.e0af8c99.png";